/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-10-16T06:39:16.290Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/casinoStoreCollection
export const CasinoStoreCollectionZod = z.union([z.literal('casino'), z.literal('live-casino'), z.literal('virtuals'), z.literal('bingo')]);
export type CasinoStoreCollectionType = z.TypeOf<typeof CasinoStoreCollectionZod>;


// #/components/schemas/casinoStoreCategoryModelWithGameIds
export const CasinoStoreCategoryModelWithGameIdsZod = z.object({
    id: z.number(),
    name: z.string(),
    active: z.boolean(),
    fixed: z.boolean(),
    visibleInNavigation: z.boolean(),
    visibleInAllGames: z.boolean(),
    gameIds: z.array(z.number()),
});
export type CasinoStoreCategoryModelWithGameIdsType = z.TypeOf<typeof CasinoStoreCategoryModelWithGameIdsZod>;


// #/components/schemas/casinoStoreProvider
export const CasinoStoreProviderZod = z.union([z.literal('evolution'), z.literal('ezugi'), z.literal('leap'), z.literal('pragmatic'), z.literal('relax'), z.literal('sg-digital'), z.literal('blueprint')]);
export type CasinoStoreProviderType = z.TypeOf<typeof CasinoStoreProviderZod>;


// #/components/schemas/casinoStoreLiveGameWebsiteModel
export const CasinoStoreLiveGameWebsiteModelZod = z.object({
    id: z.number(),
    providerGameId: z.string(),
    name: z.string(),
    demoMode: z.boolean(),
    providerId: z.number(),
    providerSlug: CasinoStoreProviderZod,
    providerName: z.string(),
    studioId: z.number(),
    studioSlug: z.string(),
    studioName: z.string(),
    published: z.boolean(),
    imageHorizontal: z.string().optional().nullable(),
    imageVertical: z.string().optional().nullable(),
    imageSquare: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    jackpotAmount: z.string().optional().nullable(),
    returnToPlayer: z.string().optional().nullable(),
    minBet: z.string().optional().nullable(),
    maxBet: z.string().optional().nullable(),
    maxWin: z.string().optional().nullable(),
});
export type CasinoStoreLiveGameWebsiteModelType = z.TypeOf<typeof CasinoStoreLiveGameWebsiteModelZod>;


// #/components/schemas/casinoStoreFetchedCategoriesAndGamesWebsiteModel
export const CasinoStoreFetchedCategoriesAndGamesWebsiteModelZod = z.object({
    categories: z.array(CasinoStoreCategoryModelWithGameIdsZod),
    games: z.array(CasinoStoreLiveGameWebsiteModelZod),
});
export type CasinoStoreFetchedCategoriesAndGamesWebsiteModelType = z.TypeOf<typeof CasinoStoreFetchedCategoriesAndGamesWebsiteModelZod>;


// #/components/schemas/casinoStoreHttpErrorResponse
export const CasinoStoreHttpErrorResponseZod = z.object({
    code: z.number(),
    message: z.string(),
});
export type CasinoStoreHttpErrorResponseType = z.TypeOf<typeof CasinoStoreHttpErrorResponseZod>;


// #/components/schemas/casinoStoreHandlerSetRecentGamePayload
export const CasinoStoreHandlerSetRecentGamePayloadZod = z.object({
    gameId: z.number(),
});
export type CasinoStoreHandlerSetRecentGamePayloadType = z.TypeOf<typeof CasinoStoreHandlerSetRecentGamePayloadZod>;


// #/components/schemas/casinoStoreRowsAffectedResult
export const CasinoStoreRowsAffectedResultZod = z.object({
    rowsAffected: z.number(),
});
export type CasinoStoreRowsAffectedResultType = z.TypeOf<typeof CasinoStoreRowsAffectedResultZod>;


// #/components/schemas/casinoStoreHandlerSetFavouriteGamePayload
export const CasinoStoreHandlerSetFavouriteGamePayloadZod = z.object({
    gameId: z.number(),
    isFavourite: z.boolean(),
});
export type CasinoStoreHandlerSetFavouriteGamePayloadType = z.TypeOf<typeof CasinoStoreHandlerSetFavouriteGamePayloadZod>;

